import axios from "../../lib/axiosInstance";

export function createEducation(payload, targetUserId) {
  return axios
    .post("education", payload, { params: targetUserId ? { targetUserId } : undefined })
    .then((res) => res.data);
}
export function fetchUserEducationList(id) {
  return axios.get(`education/all/${id}`).then((res) => res.data);
}
export function fetchUserEducation(id) {
  return axios.get(`education/${id}`).then((res) => res.data);
}
export function deleteUserEducation(id, targetUserId) {
  return axios
    .delete(`education/${id}`, { params: targetUserId ? { targetUserId } : undefined })
    .then((res) => res.data);
}

export function updateUserEducation(payload) {
  return axios
    .patch(`education/${payload.id}`, payload)
    .then((res) => res.data);
}
